module.exports = __webpack_public_path__ + "static/media/KITs_m_mr.994ba84f.jpg";